export default __webpack_public_path__ + "static/media/whatsapp.4668f8cd.svg";